
<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "ElementsManager",
        computed: {
            ...mapState('elements',[
                'registeredElements',
                'elementsManagerWrapper',
                'elementsData',
                'elementStates',
                'elementTypesMapping',
                'elementsManagerInitFlag'
            ]),
            ...mapState([
                'classSelectors'
            ])
        },
        methods: {
            ...mapActions('elements',[
                'registerElement',
                'setElementsManagerInitFlag'
            ]),
            parseElementsWrapper () {
                if (!this.elementsManagerWrapper) {
                    return;
                }
               
                let elements = this.elementsManagerWrapper.querySelectorAll(this.classSelectors.nodeWithDataTypeAttribute);

                this.validateElementInitialisation(this.elementsManagerWrapper);

                for (let index in elements) {
                    if (!elements.hasOwnProperty(index)) {
                        continue;
                    }
                    this.validateElementInitialisation(elements[index]);
                }
            },
            validateElementInitialisation (elementNode) {
                let elementTypeAttribute = elementNode.getAttribute("data-node-type");

                if (elementTypeAttribute && this.elementTypesMapping[elementTypeAttribute]) {
                    this.initElement(elementNode,elementTypeAttribute);
                }
            },
            initElement (elementNode,elementTypeAttribute) {

                let elementId = elementNode.getAttribute("id");
                let sameIdFound = false;
                let registrationData = {};


                if (elementId) {

                    this.registeredElements.find ( registeredElement => {
                        if (registeredElement.elementId === elementId || registeredElement.tempId === elementId) {
                            sameIdFound = true;
                            return true;
                        }
                    });


                    //skip already registered elements
                    if (sameIdFound && this.elementStates[elementId]) {
                        this.elementStates[elementId].findMyNode(); //if class is already initialised for this element just re-sync node context for safe precaution during html manipulation and manager reinitialisation
                        return;
                    } else if (sameIdFound) {
                        return;
                    }else {
                        registrationData["elementId"] = elementId;
                    }
                } else {
                    registrationData["tempId"] = window.createTimeID(); //create a temp ID until a class is initialised which in turn will overwrite the tempId
                }

                registrationData["elementNode"] = elementNode;
                registrationData["elementType"] = elementTypeAttribute;

                this.registerElement(registrationData);
            }
        },
        watch : {
            elementsManagerInitFlag : {
                immediate: true,
                handler () {
                    if (this.elementsManagerInitFlag) {
                        this.parseElementsWrapper();
                        this.setElementsManagerInitFlag(false);
                    }
                }

            }
        }

    }
</script>

